const ITEMS = [
  "Vi gör vårt bästa, även när ingen ser på",
  "Uusimaa Svets & VVS AB",
  "Fjärrvärmecentraler",
  "Storstockholm",
  "Yrkesstolthet & noggrannhet",
];

function Row() {
  return (
    <div className="flex w-max shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="text-outline whitespace-nowrap px-6 font-display text-4xl font-bold uppercase tracking-tight sm:text-6xl">
            {item}
          </span>
          <span className="px-2 font-mono text-sm text-weld">///</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="motto-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-white/10 bg-void py-6 sm:py-8"
    >
      <div className="flex w-max animate-marquee-x">
        <Row />
        <Row />
      </div>
    </div>
  );
}
